import React from 'react';
import { ChevronLeft } from 'react-feather';
import { useNavigate } from 'react-router-dom';

import { useOrderCreate } from './hooks/useOrderCreate';

import AddOrderProducts from './components/UI/AddOrderProducts';
import CustomerInformationSection from './components/UI/CustomerInformationSection';

const CreateOrderPage: React.FC = () => {
  const navigate = useNavigate();
  const { createOrder, isLoading } = useOrderCreate();

  const handleBack = () => {
    navigate(-1);
  };

  const handleSave = () => {
    createOrder();
  };

  return (
    <div className="h-full overflow-y-auto bg-gray-100 px-8 pb-12 pt-6">
      {/* Header */}
      <div className="flex justify-between">
        <button
          type="button"
          className="flex cursor-pointer items-center gap-3"
          onClick={handleBack}
        >
          <ChevronLeft size={24} className="text-[#888888]" />
          <h2 className="text-2xl font-bold leading-8">Create Order</h2>
        </button>
        <button
          type="button"
          className="rounded bg-[#8F689A] px-3 py-1 text-sm font-medium text-white hover:bg-opacity-80 disabled:cursor-not-allowed disabled:opacity-50"
          onClick={handleSave}
          disabled={isLoading}
        >
          {isLoading ? 'Saving...' : 'Save'}
        </button>
      </div>

      {/* Detail Section */}
      <section className="mt-8 flex w-full gap-5">
        {/* Left Section */}
        <div className="flex w-[68%] flex-col gap-5">
          {/* Total & Quantity */}
          {/* <OrderSummarySection /> */}

          {/* Order Products */}
          <AddOrderProducts />
        </div>

        {/* Right Section */}
        <div className="flex w-[32%] flex-col gap-5">
          {/* Contact & Shipping Information */}
          <CustomerInformationSection />
        </div>
      </section>
    </div>
  );
};

export default CreateOrderPage;
